import React from 'react';
import { observer } from 'mobx-react-lite';
import { debounce } from '../../../jira-common/utils/CommonUtils';
import { toSelectOption } from '../../models/SelectOption';
import { QuestionStore, toChoiceQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { isAsyncCreatable } from '../../utils/jiraFieldUtils';
import { DisplayMode } from '../RenderForm';
import { EditDropdownMultiselect } from './edit/EditDropdownMultiselect';
import { ViewDropdownMultiselect } from './view/ViewDropdownMultiselect';
export var DropdownMultiselect = observer(function (props) {
  var _questionStore$issueF;
  var id = props.id,
    questionStore = props.questionStore,
    formStore = props.formStore,
    displayMode = props.displayMode,
    customComponents = props.customComponents;
  var availableOptions = questionStore.availableOptions();
  var currentAnswer = toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer);
  var currentOptions = questionStore.getAnswerChoicesAsObjects();
  var hasOtherChoice = !!questionStore.otherChoiceId;
  var showEditComponent = displayMode === DisplayMode.Edit && !((_questionStore$issueF = questionStore.issueFieldData) !== null && _questionStore$issueF !== void 0 && _questionStore$issueF.readOnlyReason);
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2;
    var otherChoiceSelected = hasOtherChoice && currentOptions.some(function (option) {
      return option.value === questionStore.otherChoiceId;
    });
    var onChange = function onChange(values) {
      var newChoiceIds = values.map(function (option) {
        return option.value;
      });
      questionStore.setAnswer({
        text: otherChoiceSelected ? toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer).text : '',
        choices: newChoiceIds,
        // ideally - make `choices` objects, not ids, and remove `choiceObjects` prop. But ... (what's the problem? - ask Jason Thai or Banu)
        choiceObjects: values.map(QuestionStore.optionToChoice)
      });
    };
    var loadChoicesAsync = questionStore.isAsyncChoicesField ? debounce(function (inputValue, callback) {
      formStore.loadChoicesAsync(questionStore.id, inputValue).then(function (_) {
        return callback(questionStore.choices.map(toSelectOption));
      });
    }, 500) : undefined;
    var onOtherChoiceTextChange = function onOtherChoiceTextChange(event) {
      questionStore.setAnswer({
        text: event.target.value,
        choices: toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer).choices
      });
    };
    return /*#__PURE__*/React.createElement(EditDropdownMultiselect, {
      id: id,
      key: "".concat(id, "-").concat(questionStore.dependentFieldChangedCount),
      options: availableOptions,
      value: currentOptions,
      loading: questionStore.loading,
      loadOptions: loadChoicesAsync,
      isCreatable: isAsyncCreatable(questionStore),
      onChange: onChange,
      hasOtherOption: hasOtherChoice,
      otherOptionSelected: otherChoiceSelected,
      otherOptionText: currentAnswer.text,
      onOtherOptionTextChange: onOtherChoiceTextChange,
      isInvalid: !!questionStore.validationErrors,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 || (_questionStore$formQu = _questionStore$formQu.validation) === null || _questionStore$formQu === void 0 ? void 0 : _questionStore$formQu.rq,
      customComponents: customComponents,
      label: (_questionStore$formQu2 = questionStore.formQuestion) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.label
    });
  }
  return /*#__PURE__*/React.createElement(ViewDropdownMultiselect, {
    id: id,
    options: availableOptions,
    value: currentOptions,
    hasOtherOption: hasOtherChoice,
    otherOptionText: currentAnswer.text,
    displayMode: displayMode
  });
});